import { api } from "../../services/NetworkBase";

export async function GetInvoiceCharges() {
  try {
    let response = await api
      .get(`vlp/billing-maintenance/invoice-charges`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
//SaveInvoiceCharge, UpdateInvoiceCharge

export async function SaveInvoiceCharge(invoiceCharge) {
  try {
    let response = await api
      .post(`vlp/billing-maintenance/invoice-charges`, {
        json: invoiceCharge,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateInvoiceCharge(invoiceCharge) {
  try {
    let response = await api
      .put(`vlp/billing-maintenance/invoice-charges`, {
        json: invoiceCharge,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetGeneralLedgerCodes() {
  try {
    let response = await api.get(`vlp/billing-maintenance/gl-codes`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

//DeleteInvoiceCharge

export async function DeleteInvoiceCharge(id) {
  try {
    let response = await api
      .delete(`vlp/billing-maintenance/invoice-charges/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

//DeleteGeneralLedgerCode
export async function DeleteGeneralLedgerCode(id) {
  try {
    let response = await api
      .delete(`vlp/billing-maintenance/gl-codes/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

//SaveGeneralLedgerCode, UpdateGeneralLedgerCode

export async function SaveGeneralLedgerCode(invoiceCharge) {
	try {
	  let response = await api
		.post(`vlp/billing-maintenance/gl-codes`, {
		  json: invoiceCharge,
		})
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
  }
  
  export async function UpdateGeneralLedgerCode(invoiceCharge) {
	try {
	  let response = await api
		.put(`vlp/billing-maintenance/gl-codes`, {
		  json: invoiceCharge,
		})
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  